import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import Constants from "src/app/constants/constants";
import LocalizationConstants from "src/app/constants/localization-constants";
import { InternationalPhoneFormatPattern } from "src/app/constants/regex-constants";

export class FormValidators {
  static isFamCodeAllowedForUser(famCodes: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors =>
      control.value &&
      control.value.length === 3 &&
      !famCodes.some((x) => x === control.value) && {
        famCode: LocalizationConstants.VALIDATION_FAM_CODE_INVALID,
      };
  }

  static isValidIntegerPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors =>
      control.value &&
      !Constants.INTEGER_PATTERN.test(control.value) && {
        pattern: LocalizationConstants.VALIDATION_INTEGER_PATTERN_MESSAGE,
      };
  }

  static isValidInternationalPhoneNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors =>
      control.value &&
      !InternationalPhoneFormatPattern.test(control.value) && {
        pattern: LocalizationConstants.VALIDATION_INTERNATIONAL_PHONE_FORMAT,
      };
  }
}
